export default __webpack_public_path__ + "static/woman-developer-thinking-d5f38325e26f250f252133f9383403bf.jpg";